import React from 'react';
import ReactDOM from 'react-dom';
import {compose} from 'redux';

import AppStateHOC from '../lib/app-state-hoc.jsx';
import GUI from '../containers/gui.jsx';
import HashParserHOC from '../lib/hash-parser-hoc.jsx';
import {cloudflareConfig} from '../lib/cloudflare-config.js';
import log from '../lib/log.js';

const isProdBuild = typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'production';

const onClickLogo = () => {
    window.location.assign('/');
};

const onSeeCommunity = () => {
    window.location.assign('/');
};

const handleTelemetryModalCancel = () => {
    log('User canceled telemetry modal');
};

const handleTelemetryModalOptIn = () => {
    log('User opted into telemetry');
};

const handleTelemetryModalOptOut = () => {
    log('User opted out of telemetry');
};

/*
 * Render the GUI playground. This is a separate function because importing anything
 * that instantiates the VM causes unsupported browsers to crash
 * {object} appTarget - the DOM element to render to
 */
export default appTarget => {
    GUI.setAppElement(appTarget);

    // note that redux's 'compose' function is just being used as a general utility to make
    // the hierarchy of HOC constructor calls clearer here; it has nothing to do with redux's
    // ability to compose reducers.
    const WrappedGui = compose(
        AppStateHOC,
        HashParserHOC
    )(GUI);

    const bitByteDesktopMatches = window.location.href.match(/[?&]isBitByteDesktop=([^&]+)/);
    let simulateBitByteDesktop;
    if (bitByteDesktopMatches) {
        try {
            // parse 'true' into `true`, 'false' into `false`, etc.
            simulateBitByteDesktop = JSON.parse(bitByteDesktopMatches[1]);
        } catch {
            // it's not JSON so just use the string
            // note that a typo like "falsy" will be treated as true
            simulateBitByteDesktop = bitByteDesktopMatches[1];
        }
    }

    if (isProdBuild && typeof window === 'object') {
        // Warn before navigating away
        window.onbeforeunload = () => true;
    }

    ReactDOM.render(
        // important: this is checking whether `simulateBitByteDesktop` is truthy, not just defined!
        simulateBitByteDesktop ?
            <WrappedGui
                canEditTitle
                isBitByteDesktop
                showTelemetryModal
                canSave={true}
                canCreateNew={true}
                canShare={true}
                assetHost={cloudflareConfig.assetHost}
                cloudHost={cloudflareConfig.cloudHost}
                logo="/static/favicon.svg"
                onClickLogo={onClickLogo}
                onSeeCommunity={onSeeCommunity}
                projectHost={cloudflareConfig.projectHost}
                onTelemetryModalCancel={handleTelemetryModalCancel}
                onTelemetryModalOptIn={handleTelemetryModalOptIn}
                onTelemetryModalOptOut={handleTelemetryModalOptOut}
            /> :
            <WrappedGui
                assetHost={cloudflareConfig.assetHost}
                canEditTitle
                cloudHost={cloudflareConfig.cloudHost}
                showComingSoon
                canSave={true}
                canCreateNew={true}
                canShare={true}
                logo="/static/favicon.svg"
                onClickLogo={onClickLogo}
                onSeeCommunity={onSeeCommunity}
                projectHost={cloudflareConfig.projectHost}
            />,
        appTarget);
};
